import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

import {
  getActiveLang,
  getUserRole,
  getTranslationsByScope,
  DropitState,
  getTranslationsByScopes,
  getSelectedSupplierBusinessUnit,
  getSelfBusinessUnit,
} from "../../core/reducers"

import { fetchProducts, goToProduct } from "../../core/actions"

import View from "./viw_product-list"
import { getUserSelectedSupplier } from "../../core/reducers"
import { getIsgUrl } from "../../core/reducers/red_reference-isg-urls"
import { getProductList } from "../../core/reducers/red_products"

const mapStateToProps = (state: DropitState) => {
  const supplierIdSocieteg = getSelectedSupplierBusinessUnit(state)
  const selfIdSocieteg = getSelfBusinessUnit(state)

  return {
    idSocieteg: supplierIdSocieteg,
    products: getProductList(state),
    activeLang: getActiveLang(state),
    isgUrl: getIsgUrl(state, selfIdSocieteg),
    role: getUserRole(state),
    comRawData: state.miscellaneous.comTree.rawData,
    translations: getTranslationsByScopes(state, [
      "productList",
      "fieldErrors",
    ]),
    supplier: getUserSelectedSupplier(state),
    loading: state.loading.productsAreLoading > 0,
  }
}

const mapDispatchToProps = {
  fetchProducts,
  goToProduct,
}

export default withRouter(
  connect<any, any, any, DropitState>(mapStateToProps, mapDispatchToProps)(View)
)
